import { ReportChapterObject } from '../../base';
import { CaseStudies } from '../../content';

export const executiveSummary: Omit<ReportChapterObject, 'number'> = {
    id: 'executive-summary-and-recommendations',
    caption: `Executive summary and recommendations`,
    title: `GenAI boosts brings substantial productivity gains through legacy code modernization and automated testing`,
    description: null,
    editedAt: new Date(Date.now() - 4 * 60 * 60 * 1000), // 4 hours ago
    sections: [
        {
            id: '1',
            title: `Summary`,
            caption: null,
            content: [
                {
                    kind: 'text',
                    text: `Leading companies are achieving 20-40% productivity gains by strategically implementing GenAI across software maintenance workflows. Organizations like Slack, TikTok, and AT&T have successfully deployed AI-assisted solutions for legacy code modernization, automated testing, and bug fixes—enabling developers to shift focus from routine maintenance to innovation.`,
                },
                {
                    kind: 'text',
                    text: `Early adopters report significant time savings, with up to 80% success rates in code conversion projects, substantial improvements in test coverage (from 3% to 50%), and successful migrations of complex legacy systems that would otherwise require thousands of engineering hours.`,
                },
            ],
            keywords: [],
            sources: [],
        },
        {
            id: '2',
            title: `Recommendations`,
            caption: null,
            content: [
                {
                    kind: 'text',
                    text: `To capture similar benefits, prioritize targeted GenAI implementations in automated testing and incremental legacy code modernization—areas consistently delivering rapid ROI across enterprises.`,
                },
                {
                    kind: 'text',
                    text: `Deploy GitHub Copilot or Cursor for immediate developer productivity gains, while establishing secure private endpoints through Azure OpenAI or similar services for sensitive codebases.`,
                },
                {
                    kind: 'text',
                    text: `Start with hybrid approaches combining traditional methods with LLM-driven solutions for optimal accuracy.`,
                },
                {
                    kind: 'text',
                    text: `Importantly, plan for comprehensive developer training and upskilling, as most organizations struggle with adoption rates beyond 50% due to knowledge gaps rather than tool deficiencies.`,
                },
                {
                    kind: 'text',
                    text: `Start with hybrid approaches combining traditional methods with LLM-driven solutions for optimal accuracy.`,
                },
                {
                    kind: 'text',
                    text: `By focusing on these areas, you can achieve demonstrable productivity gains within 3-6 months while building a foundation for broader AI integration.`,
                },
            ],
            keywords: [],
            sources: [],
        },
    ],
};
